import ThronVideo from '@components/utils/ThronVideo';
import classNames from 'classnames';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
const RichVideo = (props) => {
    const card = typeof props.card === 'string' ? JSON.parse(props.card) : props.card;
    const { t } = useTranslation();
    const textWrapper = useRef();
    // const [neverPlayed, setNeverPlayed] = useState(true);
    // const firstPlay
    const onPlayCallback = (isFirstPlay) => {
        var _a, _b, _c;
        if (isFirstPlay) {
            (_a = textWrapper.current) === null || _a === void 0 ? void 0 : _a.classList.add('delay-3000');
            (_b = textWrapper.current) === null || _b === void 0 ? void 0 : _b.classList.remove('aos-init', 'aos-animate');
            // setTimeout(() => (textWrapper.current as HTMLElement)?.classList.remove('aos-init', 'aos-animate'), 3000);
        }
        else {
            (_c = textWrapper.current) === null || _c === void 0 ? void 0 : _c.classList.remove('aos-init', 'aos-animate');
        }
    };
    return (React.createElement("div", { className: classNames('rich-video__block', card.borderStyle, card.volumeToggle && 'no-volume', card.timerailToggle && 'no-timerail') },
        React.createElement("div", { className: "rich-video__div rich-video__video" },
            React.createElement("div", { className: "rich-video__inner-container" },
                React.createElement(ThronVideo, { thronID: card.thronID, thronMobileID: card.thronMobileID, autoplay: !window.matchMedia('(prefers-reduced-motion: reduce)').matches, muted: !!card.volumeToggle, noskin: false, loop: typeof card.loopTimes !== 'number', loopTimes: card.loopTimes, lockBitrate: card.lockBitrate && 'max', className: `${card.imgGradient ? 'image-background--' + card.imgGradient.toLowerCase() : ''} ${card.gradientSize ? 'image-background--' + card.gradientSize.toLowerCase() : ''}`, onPlayCallback: onPlayCallback, onPauseCallback: () => {
                        var _a, _b;
                        (_a = textWrapper.current) === null || _a === void 0 ? void 0 : _a.classList.remove('delay-3000');
                        (_b = textWrapper.current) === null || _b === void 0 ? void 0 : _b.classList.add('aos-init', 'aos-animate');
                    }, onCompleteCallback: (player) => {
                        player.play();
                    } }))),
        React.createElement("div", { className: "rich-video__text-wrapper container aos-init aos-animate", ref: textWrapper, "data-anim": "fade-up" },
            card.title && React.createElement("p", { className: "rich-video__title" }, card.title),
            card.description && React.createElement("h3", { className: "rich-video__description" }, card.description))));
};
export default RichVideo;
